// @ts-nocheck
import { useMemo } from 'react';
import { Box } from '@mui/material';
import { TenantSettingsPropTypes } from '../types';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './Amenities.css';
import Editor from '../../../../Editor/Editor';
import { isAmenityDescriptionEmpty } from '../../../../../utils/amenitiesHelper';

export const Amenities = ({ tenantsettings, amenities }) => {
  const { t } = useTranslation('common');

  const includedAmenities = useMemo(() => {
    return amenities?.filter((amenity) => amenity.isincluded) || [];
  }, [amenities]);

  const excludedAmenities = useMemo(() => {
    return amenities?.filter((amenity) => amenity.isincluded === false) || [];
  }, [amenities]);

  // Do not display the component if there are no amenities included or excluded.
  if (includedAmenities.length === 0 && excludedAmenities.length === 0) {
    return null;
  }

  return (
    <Box
      className='amenities-section'
      id={`amenities-section`}
      fontFamily={tenantsettings?.bodyfont || 'inherit'}
    >
      {includedAmenities.length > 0 && (
        <Box className='amenities-section__included'>
          <h5
            className='amenities-section__title'
            style={{ fontFamily: tenantsettings?.headingfont || 'inherit' }}
          >
            {t('Included')}
          </h5>
          <ul className='amenities-section__list'>
            {includedAmenities.map((amenity) => (
              <li key={amenity.amenityid}>
                <p
                  style={{
                    fontFamily: tenantsettings?.bodyfont || 'inherit'
                  }}
                >
                  <b className='amenities-section__list-name'>{amenity.name}</b>
                  {!isAmenityDescriptionEmpty(amenity) && (
                    <Editor
                      content={amenity?.description}
                      editable={false}
                      isPreviewing={true}
                    />
                  )}
                </p>
              </li>
            ))}
          </ul>
        </Box>
      )}
      {excludedAmenities.length > 0 && (
        <Box className='amenities-section__excluded'>
          <h5
            className='amenities-section__title'
            style={{ fontFamily: tenantsettings?.headingfont || 'inherit' }}
          >
            {t('Excluded')}
          </h5>
          <ul className='amenities-section__list'>
            {excludedAmenities.map((amenity) => (
              <li key={amenity.amenityid}>
                <p
                  style={{
                    fontFamily: tenantsettings?.bodyfont || 'inherit'
                  }}
                >
                  <b className='amenities-section__list-name'>{amenity.name}</b>
                  {!isAmenityDescriptionEmpty(amenity) && (
                    <Editor
                      content={amenity?.description}
                      editable={false}
                      isPreviewing={true}
                    />
                  )}
                </p>
              </li>
            ))}
          </ul>
        </Box>
      )}
    </Box>
  );
};

Amenities.propTypes = {
  ...TenantSettingsPropTypes,
  amenities: PropTypes.arrayOf(
    PropTypes.shape({
      amenityid: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string,
      included: PropTypes.bool,
      excluded: PropTypes.bool
    })
  )
};

export default Amenities;
